import { useState, useEffect } from 'react'
import { ButtonFilledAutoWidth, ButtonOutlinedAutoWidth } from '../../components/button'
import { DatePicker, Modal, Select } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { FiChevronRight, FiChevronLeft } from 'react-icons/fi';
import { IconButton } from '@material-ui/core';
import { AiOutlineEdit, AiOutlineDelete, AiOutlineFileExcel } from 'react-icons/ai';
import toast from 'react-hot-toast';
import axios from 'axios';
import fileDownload from "js-file-download";
import { GetSearchService } from '../../services/AuthServices'
import moment from 'moment';
import { useSelector } from 'react-redux';
import { DeleteClientService, DownloadClientService, GetClientService, GetTrackEmployeeWorkStatusService } from '../../services/ClientServices';
import { CgRadioCheck,CgRadioChecked } from "react-icons/cg";
import DashboardMenu from './DashboardMenu';
import { useSearchParams } from 'react-router-dom';
import { MdOutlineCallToAction } from "react-icons/md";


function TrackEmployeeClientsDetail() {

  const navigator = useNavigate()
  const {state} = useLocation()

  console.log("state",state)
  const roles = useSelector(state=>state.Auth.roles)

  const [searchParams] = useSearchParams();
  const search_type = searchParams.get('type'); 

  console.log("search_type -->",search_type)

  const [step, setstep] = useState("Client Assigned")

  let stages = ['Client Assigned','Client Intrested','Call Not Recieved','Customer Subscribed','App Installed','Remarks','Edit Open']



  const [modal, setmodal] = useState(false)
  const [page, setpage] = useState(1)
  const [data, setdata] = useState({})
  const [selecteddata, setselecteddata] = useState({})

  const [users,setusers] = useState([])

  const [search, setsearch] = useState({ text: '', from_date: '', to_date: '',date:moment(state?.date),date1:state?.date1,from_date1: '', to_date1: '', activate: false,user:state?.user })
  
console.log("search",search)

  useEffect(() => {
   if(search.user && search.date1){
     getdata();
  }
  }, [search?.user, search?.date1])

  async function getdata() {
    const response = await GetTrackEmployeeWorkStatusService(search?.date1, search?.user?.value ?? search?.user)
    setdata(response?.data?.data[0])
  }


  async function applyFilter() {
    setsearch({ ...search, activate: true })
    setpage(1)
    const response = await GetTrackEmployeeWorkStatusService(search?.date1, search?.user?.value ?? search?.user)
    setdata(response?.data?.data[0])
  }

  async function resetfilter() {
    setsearch({ text: '', from_date: '', to_date: '',date:'',date1:'', from_date1: '', to_date1: '', activate: false, user: '' })
    setpage(1)
    setdata({})
    // const response = await GetTrackEmployeeWorkStatusService('', '')
    // setdata(response?.data)
  }

  async function deleteData() {
    const response = await DeleteClientService(selecteddata?._id)
    if (response?.status === 200) {
      toast.success("Deleted Successfully")
    } else {
      toast.success("Deleted Successfully")
    }
    setmodal(false)
    getdata()
  }

  async function downloaddata() {
    const response = await DownloadClientService(1, search?.text, search?.from_date1, search?.to_date1, '')
    let path = response.data.path.replace('public/', '')
    let url = `${process.env.REACT_APP_BACKEND_IMAGE_URL}${path}`
    window.open(url,'_blank')
    // handleDownload(`${process.env.REACT_APP_BACKEND_IMAGE_URL}${path}`, path.split('/')[path.split('/')?.length - 1])
  }

   async function searchemployee(e){
    const response = await GetSearchService(e,1)
    let arr = []
    response?.data?.datas?.forEach((d)=>{
      arr.push({label:d?.name,value:d?._id})
    })
    setusers(arr)
  }

  const handleDownload = (url, filename) => {
    axios.get(url, {
      responseType: 'blob',
    })
      .then((res) => {
        fileDownload(res.data, filename)
      })
  }


  function openFile(v){
    let url = `${process.env.REACT_APP_BACKEND_IMAGE_URL}${v}`
    window.open(url,'_blank')
  }

  const mapping = {
    "Client Assigned": data?.customer_assigned,
    "Client Intrested": data?.customer_interested,
    "Call Not Recieved": data?.call_not_received_interested,
    "Customer Subscribed": data?.customer_subscribed,
    "App Installed": data?.customer_app_installed,
    "Remarks": data?.remarks,
    "Edit Open": data?.editopen
  };

  const renderData = mapping[step] || null;


  return (
    <div className='w-[98%] md:h-screen md:overflow-hidden'>

      <Modal
        keepMounted
        open={modal}
        onClose={() => setmodal(false)}
        width={300}
        footer={false}
        closable={false}

      >
        <div >
          <h6 className="font-bold text-[15px] text-center mb-2 w-full">Are you sure?</h6>
          <h6 className='bg-slate-100 text-center text-[12px] p-1.5 font-[400]'>After deleting you cannot retrieve it back before deleting check once whether you have used it in some data</h6>
          <div className='flex justify-end mt-3 '>
            <ButtonOutlinedAutoWidth btnName={'Cancel'} onClick={() => setmodal(false)} />
            <div className='ml-2'>
              <ButtonFilledAutoWidth btnName={'Confirm'} onClick={() => deleteData()} />
            </div>
          </div>
        </div>
      </Modal>

      <div className='md:flex'>
        <div>
          <DashboardMenu />
        </div>
        <div className='md:w-[90%] pl-5 mt-4'>

          <div className='md:flex items-center -mt-1 border-b justify-between pb-1'>
            <div className='flex items-center justify-between'>
            <h6 className='font-[800] text-[13px]'>Track Employee Detail</h6>
        
            </div>

            <div className='flex flex-wrap items-center text-[12px]'>
              <DatePicker  size='small' style={{ fontSize: '11px' }} ampm={false} placeholder='Date' className='text-[11px] py-[2.6px]  w-28 border-slate-300 mr-2' value={search?.date} onChange={(v, v1) => { console.log('v na', new Date(v).toLocaleDateString()); setsearch({ ...search, date: v, date1: v1 }) }} />

              <div className='mr-2 w-[130px]'>
                <Select 
                  showSearch
                  filterOption={false}
                  value={search?.user == '' ? null : search?.user}
                  bordered={false}
                  onSearch={searchemployee}
                  className='border rounded h-[29px] border-slate-300 w-[100%] place-holder:text-[10px]'
                  options={users}
                  placeholder={<span className="text-[12px] text-gray-300 ">Select User</span>}
                  onChange={(e)=>setsearch({...search,user:e})}
                  />
              </div>      
              <div className='mr-2 mt-1 md:mt-0'>
                <ButtonOutlinedAutoWidth btnName="Apply Filter" onClick={() => applyFilter()} />
              </div>
              <div className='mr-2 mt-1 md:mt-0'>
                <ButtonOutlinedAutoWidth btnName="Reset Filter" onClick={() => resetfilter()} />
              </div>
            </div>
          </div>

           
         
        

          {search?.user && <>
          <div className='flex items-center border-b overflow-x-auto flex-nowrap'>
                {stages?.map((s)=>(
                <h6 onClick={()=>{setstep(s)}} className={`font-[600] ${step === s && 'bg-[#2a297e] text-white'} flex-shrink-0 text-center cursor-pointer py-1 w-auto px-2 text-[11px]`}>{s}</h6>
                ))}
          </div>

          <div className='md:h-[90vh] mb-[50px] md:overflow-hidden'>

            {data?.datas?.length === 0 &&
              <div className='grid place-items-center mt-20  items-center justify-center'>
                <img src={'https://fidecrmfiles.s3.amazonaws.com/NoDataFound1.png'} className='w-40 h-40 object-contain' />
                <h6 className='font-bold text-[14px] -mt-10'>No data found</h6>
                <h6 className='font-[500] w-[70%] text-center text-slate-700 text-[12.5px] -mt-2'>Oops we couldn't find any data based on your current stage please add the data to see list here.</h6>
              </div>}

            <div className='w-[100%] overflow-hidden'>
              {renderData?.length > 0 &&
                <>
                <h6 className='text-[13px] mt-2'>Total Data : <span className='font-[800]'>{renderData?.length}</span></h6>
                <div className='md:max-h-[85vh] mt-4 md:overflow-auto border-t border-l border-r'>
                  <div className='sticky top-0 z-50 flex w-max md:w-[100%]  bg-white py-[-5px] border-b border-slate-200 relative'>
                    <h6 className='top-0 bg-white z-50 text-[12px] min-w-[50px] w-[50px]  md:min-w-[50px]  md:w-[50px]  px-2 py-1 font-[600] text-slate-800 border-r flex items-center justify-center'>Sl No</h6>
                    <h6 className='sticky top-0 z-50  text-[12px]  min-w-[180px] w-[180px]  md:min-w-[180px]  md:w-[180px]  px-2 py-1 font-[600] text-slate-800 border-r'>Client Name</h6>
                    <h6 className='sticky top-0 z-50  text-[12px]  min-w-[160px] w-[160px]  md:min-w-[160px]  md:w-[160px]  px-2 py-1 font-[600] text-slate-800 border-r'>Mobile </h6>
                    <h6 className='sticky top-0 z-50  text-[12px]  min-w-[160px] w-[160px]  md:min-w-[160px]  md:w-[160px]  px-2 py-1 font-[600] text-slate-800 border-r'>Email</h6>
                    <h6 className='sticky top-0 z-50  text-[12px] min-w-[180px] w-[180px]  md:min-w-[180px]  md:w-[180px]  px-2 py-1 font-[600] text-slate-800 border-r'>Remarks</h6>
                    <h6 className='sticky top-0 z-50  text-[12px] min-w-[180px] w-[180px]  md:min-w-[180px]  md:w-[180px]  px-2 py-1 font-[600] text-slate-800 border-r'>Intested  / Subscribed</h6>
                    <h6 className='sticky top-0 z-50  text-[12px] min-w-[120px] w-[120px]  md:min-w-[120px]  md:w-[120px]  px-2 py-1 font-[600] text-slate-800 border-r'>Created At</h6>
                    <h6 className='sticky top-0 z-50  text-[12px] min-w-[80px] w-[80px]  md:min-w-[80px]  md:w-[80px]  px-2 py-1 font-[600] text-slate-800 '>Actions</h6>
                  </div>
                  {renderData?.map((d, i) => (
                    <div className='flex w-max md:w-[100%] text-[11px]  bg-white py-[-5px] border-b border-slate-200 relative'>
                      <h6 className='bg-white text-[12px] min-w-[50px] w-[50px]  md:min-w-[50px]  md:w-[50px]   px-2 py-1 font-[500] border-r flex items-start justify-center'>{(page > 1 ? i + 1 + (data?.pagination?.limit * (page - 1)) : i + 1)}</h6>
                      <h6 className=' text-[11px] break-word min-w-[180px] w-[180px]  md:min-w-[180px] md:w-[180px] px-2 py-1 border-r'>
                        <span className='font-bold'>{d?.name}</span>
                        <br></br>
                        <h6>Handled By :</h6>
                        {d?.handled_by?.map((h)=>(<span className='font-bold text-blue-500'>{h?.name},</span>))}
                        {d?.session_status && <h6 className='text-[13px] w-max bg-green-200 text-green-900 p-1 text-[8px] font-[600]'>Session Active</h6>}

<h6 className='text-[11px]  font-[600] capitalize'>Source System :  {d?.source} </h6>
                      </h6>
                      <h6 className=' text-[12px] break-word min-w-[160px] w-[160px]  md:min-w-[160px]  md:w-[160px] px-2 py-1 font-[500] border-r'>
                        <span className='font-bold'>{d?.mobile}</span><br></br>
                        {d?.mobile?.length > 10 && <span className='bg-green-100 p-[4px] text-green-800'>True</span>}
                      </h6>
                      <h6 className=' text-[12px] break-all min-w-[160px] w-[160px]  md:min-w-[160px]  md:w-[160px]  px-2 py-1 font-[500] border-r'>
                       {d?.email}
                      </h6>
                      <h6 className=' text-[11px] break-word min-w-[180px] w-[180px]  md:min-w-[180px]  md:w-[180px]  px-2 py-1  border-r'>
                        {d?.remarks}
                      </h6>
                      <h6 className='flex   break-word  min-w-[180px] w-[180px]  md:min-w-[180px]  md:w-[20px] px-2 py-1 font-[500] border-r'>{!d?.interested ? <CgRadioCheck size={15} className='text-slate-300' /> : <CgRadioChecked size={15} className='text-yellow-500' />} <span className='mx-2 text-slate-300'>/</span>  {!d?.subscribed ? <CgRadioCheck size={15} className='text-slate-300' /> : <CgRadioChecked size={15} className='text-yellow-500' />}  </h6>
                      <h6 className='  break-word min-w-[120px] w-[120px]  md:min-w-[120px]  md:w-[120px]  px-2 py-1 font-[500] border-r'>{moment(d?.createdAt)?.format('LLL')}</h6>
                      <h6 className='flex items-start  min-w-[80px] w-[80px]  md:min-w-[80px]  md:w-[80px] px-2 py-1 font-[500] '>
                        <AiOutlineEdit onClick={() => navigator('edit', { state: d })} className='mr-2' />
                        <MdOutlineCallToAction onClick={() => navigator('/clients/list/edit', { state: d })} className='mr-2' />
                        {roles.includes('admin') && <AiOutlineDelete onClick={() => { setselecteddata(d); setmodal(true) }} />}
                      </h6>
                    </div>))}
                </div>
                </>}
            </div>

          </div>
          </>}

        </div>
      </div>
    </div>
  )
}

export default TrackEmployeeClientsDetail